const ClientInvoiceStatusOptionsArray = [
  { value: 'Draft', label: 'Draft' },
  { value: 'Finalized', label: 'Finalized' },
  { value: 'Paid', label: 'Paid' },
  { value: 'Cancelled', label: 'Cancelled' },
];

export default ClientInvoiceStatusOptionsArray;
